"use strict";
exports.__esModule = true;
var isClient = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
exports["default"] = isClient;
